import React, { useMemo, useState } from 'react';
import styles from "./styles.module.scss";
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { classnames, navigations } from '../../utils';
import { useNavigate } from '../../hook';
import { useTranslation } from 'react-i18next';
import * as Icons from '../Icons';
import { toggleDisableOpenMenu, toggleNotifyTinIsInValid } from '../../store/utilsSlice';
import axios from '../../api/axios';
import loadingImage from '../../assets/images/loadingImg.gif';

export function Navigation() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const params = useParams();
    const dispatch = useDispatch();
    const auth = useSelector((state: any) => state.auth);
    const utils = useSelector((state: any) => state.utils);
    const [loading, setLoading] = useState<any>({});

    const navigation = useMemo(() => navigations
                                                .filter((nav) => nav.roles?.includes(auth.role))
                                                .filter(nav => nav.path !== '/api/taxi/token'), [auth.role]
    );

    const handleNavigate = (nav: { path: string, disableMenuForWithoutTin?: boolean, urlFromBe?: boolean }) => (event: React.MouseEvent<HTMLLIElement>) => {
        const { path, disableMenuForWithoutTin, urlFromBe } = nav;
        event.stopPropagation();
        if(!!urlFromBe) {
            if(!loading[path]) {
                setLoading((prev: any) => ({ ...prev, [path]: true }));
                axios.get(path ?? "")
                    .then((res) => {
                        window.open(res.data.url ?? res.data.taxiAppUrl, '_blank');
                    })
                    .catch((err) => {
                        console.log(err, "-----> error");
                    })
                    .finally(() => {
                        setLoading((prev: any) => ({ ...prev, [path]: false }));
                    })
            }
            return;
        }
        if (disableMenuForWithoutTin && !auth.tin) {
            dispatch(toggleDisableOpenMenu(true));
            return;
        }
        if (disableMenuForWithoutTin && auth.tin && !utils.tinIsValid) {
            dispatch(toggleNotifyTinIsInValid(true));
            return;
        }
        navigate(path);
    }

    const getSelectedNav = (path: string) => {
        return pathname.replace(`/${params.lngCode}`, "") === path
    }

    return (
        <nav className={styles.InnerNavbar}>
            <ul className={styles.NavbarList}>
                {navigation.map((nav) => (
                    <li 
                        className={styles.NavItem} 
                        onClick={handleNavigate(nav)}
                        key={nav.translateKey}
                    >
                        {t(nav.translateKey)}
                        <span className={classnames({[styles.Loading]: true, [styles.Show]: loading[nav.path] })}>
                            <img src={loadingImage} alt='loading' />
                        </span>
                        {!!nav.subMenu.length && <span className={styles.Arrow}><Icons.ArrowDown/></span>}
                        {getSelectedNav(nav.path) && <div className={styles.Selected} />}
                        {!!nav.subMenu.length && (
                            <ul className={styles.SubMenu}>
                                {nav.subMenu.map((subMenu) => (
                                    <li key={subMenu.translateKey} onClick={handleNavigate(subMenu)}>
                                        {t(subMenu.translateKey)}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))}
            </ul>
        </nav>
    );
}
